var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 248,
    viewBox: "0 0 248 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.37,
    cy: 124.37,
    r: 91.37,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.75 63C150.368 63 153.281 65.9137 153.281 69.5312V77.75H161.5C170.188 77.75 177.25 84.8122 177.25 93.5V167.25C177.25 175.938 170.188 183 161.5 183H87.75C79.0622 183 72 175.938 72 167.25V93.5C72 84.8122 79.0622 77.75 87.75 77.75H95.9688V69.5312C95.9688 65.9137 98.8825 63 102.5 63C106.118 63 109.031 65.9137 109.031 69.5312V77.75H140.219V69.5312C140.219 65.9137 143.132 63 146.75 63ZM85.0625 167.25C85.0625 168.726 86.2742 169.938 87.75 169.938H161.5C162.976 169.938 164.188 168.726 164.188 167.25V109.25H85.0625V167.25Z",
    fill: "#2F2E41",
    stroke: "#333333",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.281 123.929C142.836 121.375 146.976 121.369 149.512 123.933C152.032 126.48 152.072 130.611 149.51 133.153L149.51 133.154L145.209 137.478L123.719 158.969C121.165 161.522 117.029 161.529 114.492 158.969L99.7419 144.219C97.1871 141.664 97.1818 137.525 99.7458 134.988C102.294 132.467 106.427 132.427 108.969 134.992L119.094 145.117L140.281 123.929Z",
    fill: "#FFD300",
    stroke: "#333333",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.490a7a5b74a7dbd343e99cf7b9990775.svg";
export { ForwardRef as ReactComponent };